import { IAppState } from '../../redux';
import { IPublishOption } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectActivePackage(state: IAppState): IPublishOption | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { packages, selectedPackageId },
  } = selectedService;

  if (!selectedPackageId) {
    return null;
  }

  return packages[selectedPackageId];
}
